import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Helmet } from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: ${({padding}) => (padding) ? padding : '4rem 0'};
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const AnovaFurnishings = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: Anova Furnishings | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="Anova Furnishings"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/anova_hero.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Grocery</IndustryTag>
            <IndustryTag>Retail</IndustryTag>
            <IndustryTag>CPG</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About Anova Furnishings
          </H3>
          <P>
            Family owned and headquartered in St. Louis, Anova has been a leading innovator in site furnishings in terms of both design and manufacturing for over 40 years. By controlling the entire design, engineering, and manufacturing process, Anova's holistic approach provides customizers with a combination of customization and quality rarely found in furnishings today. Upbeat Site Furnishings, Anova's sister company, has established itself as the premier direct mail catalog and web marketer of B2B site furnishings.
          </P>
          <P>
            Together, Anova and Upbeat represent over 50 manufacturers of quality products such as tables, benches, recyclers, and much more. Anova and Upbeat partnered with RMG to modernize their frontend experience and streamline the management of their multi-store content and catalog.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Backend Development</ServiceName>
              <ServiceName>Frontend Development</ServiceName>
              <ServiceName>Software Architecture Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Devops</ServiceTag>
              <ServiceName>Application &amp; Infrastructure Support</ServiceName>
              <ServiceName>Managed Cloud Hosting</ServiceName>
              <ServiceName>Software Development Lifecycle Management</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/anova_img_01.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>Anova helps businesses design spaces that enhance landscapes, strengthen communities, and positively impact the environment by transforming sustainable materials into beautiful, comfortable, and durable furnishings. Anova's products help their customers obtain credits toward LEED certification (Leadership in Energy and Environmental Design) while minimizing their own carbon footprint through advanced manufacturing techniques, environmentally friendly practices, and recycling materials whenever possible.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>As their selection of outdoor furnishings continued to grow, Anova partnered with RMG to modernize their brand experience and present their products with the same level of elegance as their designs. In order to create a future-proof brand experience that works both online and off, RMG built a progressive web app (PWA) with a React frontend and decoupled it from Anova's Drupal backend. RMG then moved Anova's catalog from Drupal to Magento 2 and helped them manage their diverse library of content by creating custom content types with pre-defined templates such as case studies and grant proposals.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/anova_img_02.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/anova_img_03.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>RMG updated the data structures on Upbeat.com to follow the same rules as Anova's. By using the same backend data structures, designs for the product picker, and image standards, Anova could manage a single catalog and content library that powers both sites. On top of these changes, RMG streamlined the catalog by building a custom "portfolio" entity that allows prospective customers to find items by theme (modern, classic, traditional, natural) instead of by item type (bench, table, recycling bin, etc.).</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>Focus then shifted to simplifying, updating, and automating the connections between Upbeat's commerce systems and procurement systems. RMG created two-way integrations to the vendor systems used by Anova's biggest clients, allowing for the handling of custom order information between specific customer portals and fulfillment centers while also pushing the order information back to Magento. RMG also built a product customizer, usable on both websites, that merges multiple images based on options selected by the user. As selections are made, the customizer automatically layers images to build real-time product previews and create the right specifications for fulfillment.</P>
            <P>Together, these changes help Anova scale their business as their catalog, supplier list, and customer base continue to expand. The result for Anova is a modern, easy to manage shopping experience with content and customization options that delight customers and promote sustainability.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/anova_img_04.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <Container>
      <Row>
        <NavCol col={12}>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                        to={`/portfolio/h-e-b`}
                        buttonText="H-E-B" />
          <NavSpan>/</NavSpan>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/cbdmd`}
                        buttonText="cbdMD" />
        </NavCol>
      </Row>
    </Container>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useArrow
                useBorderTop
    />
    <PageNavigation prev="capabilities" next="insights" />
  </Fragment>;
};

export default withRouter(AnovaFurnishings);